// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1jkvp","alertIcon":"ConfirmModal_alertIcon__15ZHI"};